/** How often the console re-reads while every job is idle, and while any run is in progress. */
export const POLL_IDLE_MS = 30_000;
export const POLL_RUNNING_MS = 3_000;

export const RUNS_PAGE_SIZE = 25;

/** Rows per page of a run's events, read from the server. */
export const EVENTS_PAGE_SIZE = 50;

/** The one unfiltered read behind a run's "By code" panel and its code filter; the gateway's largest page. */
export const EVENTS_SUMMARY_SIZE = 100;

/** Runs shown on a job's own page, before the link to all of them. */
export const JOB_RECENT_RUNS = 5;

export const ALL_FILTER_VALUE = 'all';

/** Said wherever an action is shown disabled for someone who may read but not start. */
export const NEEDS_MANAGE_TEXT = 'Starting a run needs an administrator role.';
export const READ_ONLY_CAPTION = `${NEEDS_MANAGE_TEXT} You can view everything here.`;
